export const ContentType = {
  MultiPartFormData: "multipart/form-data",
  ApplicationJson: "application/json",
  UrlEncoded: "application/x-www-form-urlencoded",
};
